<template>
  <div class="page--table-container">
    <div class="tool-container">
      <div class="tool_form-container">
        <slot name="toolForm"></slot>
      </div>
      <div class="tool_btn-container">
        <slot name="toolBtn"></slot>
      </div>
    </div>
    <div class="table-container">
      <slot></slot>
    </div>
    <div class="pagination">
      <el-pagination
        v-model:current-page="pageInfo.page"
        v-model:page-size="pageInfo.limit"
        :page-sizes="pageSizes"
        background
        :layout="pageLayout"
        :total="count"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script setup>
import { pageSizes, pageLayout } from "@/utils/constant.js";
import { reactive, defineEmits, defineProps } from "vue";

const props = defineProps({
  count: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(["sizeChange", "currentChange"]);

const pageInfo = reactive({
  page: 1,
  limit: 10,
});

const handleSizeChange = (val) => {
  pageInfo.limit = val;
  emit("sizeChange", pageInfo.limit);
};

const handleCurrentChange = (val) => {
  pageInfo.page = val;
  emit("currentChange", pageInfo.page);
};
</script>
